const tooltip = () => {
    const docBody = $(document.body);
    const tooltipWrapper = '.info-icon';

    docBody.on('mouseenter', tooltipWrapper, (e) => {
        const currentTooltip = $(e.currentTarget).find('.tooltip');
        if (currentTooltip.length) {
            const tooltipClass = currentTooltip.offset().left < 0 || currentTooltip.offset().left > window.innerWidth ? 'normal active' : 'active';
            currentTooltip.addClass(tooltipClass);
        }
    });

    docBody.on('mouseleave', tooltipWrapper, (e) => {
        const currentTooltip = $(e.currentTarget).find('.tooltip');
        if (currentTooltip.length) {
            currentTooltip.removeClass('active normal');
        }
    });
};

module.exports = {
    tooltip,
};
